import { TableCellTypes } from '@carboledger/ui';
import {
  buildLinkOrdersStep1Columns,
  orderUnits,
  makeRemoveCell,
  buildLinkedGroups,
  getLinkedGroup,
} from '@/components/common';
import { useGetLinkableOrdersQuery } from '@/lib/api/linksApi';

// Outgoing shipments ▸ Fulfil ▸ Select order — config for <SelectFromTable>.

// PickFromTableModal owns the radio, so the shared builder is asked for its data columns only.
const buildColumns = (t, { unitHeaderSelect, onOpenDiscrepancy }) =>
  buildLinkOrdersStep1Columns(t, { headerSelect: unitHeaderSelect, onOpenDiscrepancy });

const buildSelectedColumns = (t, { unitHeaderSelect, onRemove }) => [
  ...buildLinkOrdersStep1Columns(t, { headerSelect: unitHeaderSelect }),
  {
    id: '__remove__',
    header: t('FIELD_ACTION'),
    type: TableCellTypes.custom,
    width: 120,
    resizable: false,
    cell: makeRemoveCell(onRemove),
  },
];

// The shipment decides which orders it can fulfil; the server derives that match from its id.
const useCandidates = ({ context, search, page, pageSize, enabled }) => {
  const shipmentId = context?.record?.id;
  const { data, isFetching } = useGetLinkableOrdersQuery(
    { shipmentId, search, page, pageSize },
    { skip: !shipmentId || !enabled },
  );
  return { rows: data?.rows, total: data?.totalCount, loading: isFetching };
};

// Orders already linked to this shipment first, then every other candidate (ENG-1187).
const buildGroups = (t) =>
  buildLinkedGroups(t, {
    linkedKey: 'PICKER_GROUP_LINKED_ORDERS',
    otherKey: 'PICKER_GROUP_OTHER_ORDERS',
  });

// One order per fulfilment, so the picked row replaces rather than appends.
const writeSelection = ({ selected, setValue }) => {
  setValue('pendingOrderId', selected[0]?.id ?? '');
};

export const SELECT_ORDER_CONFIG = Object.freeze({
  // Where the section sits
  name: 'selectOrder',
  sectionHeadingKey: 'OUTGOING_SHIPMENTS_FULFILL_SECTION_ORDER',
  missingKey: 'OUTGOING_SHIPMENTS_FULFILL_ORDER_REQUIRED',

  // The button and the modal's chrome
  titleKey: 'OUTGOING_SHIPMENTS_FULFILL_SELECT_ORDER',
  buttonKey: 'OUTGOING_SHIPMENTS_FULFILL_SELECT_ORDER',
  promptKey: 'OUTGOING_SHIPMENTS_FULFILL_SELECT_ORDER_PROMPT',
  emptyKey: 'OUTGOING_SHIPMENTS_FULFILL_ORDERS_EMPTY',
  selectMode: 'single',
  filterable: true,

  // The modal's own table
  buildColumns,
  unitOptions: orderUnits.buildUnitHeaderOptions,
  buildGroups,
  getRowGroup: getLinkedGroup,

  // The picked rows
  buildSelectedColumns,

  // The section's own data
  useCandidates,
  writeSelection,
});
